import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnmarApiService } from '../anmar-api.service';
import { AnmarBaseListComponent } from '../shared/anmar-base-list.component';
import { ANMAR_RESOURCES } from '../shared/anmar-resources';

@Component({ selector: 'app-anmar-sections-list', templateUrl: '../blog/blog-list.component.html' })
export class AnmarSectionsListComponent extends AnmarBaseListComponent {
  config = ANMAR_RESOURCES['sections'];
  constructor(api: AnmarApiService, router: Router, toastr: ToastrService) { super(api, router, toastr); }
}
